module.exports = __webpack_public_path__ + "media/pricing/Mosaics-f00b44f8.jpg";